import {footer} from "./custom/footer";
import {elements} from "./custom/elements";

export function global() {
    footer();
    elements();
}
